module.exports = __webpack_public_path__ + "static/media/eymeric-segard-founder-and-chairman-lunalogistik.7d627bbe.jpg";